{
  "runInsights": {
    "exceptions": {
      "bucketCount": "{{count}}×",
      "title": "Excepciones",
      "failedCount": "{{count}} cartera(s) fallaron la validación",
      "skippedCount": "{{count}} cartera(s) omitidas",
      "bucketsTitle": "Problemas comunes de validación",
      "examplesTitle": "Ejemplos"
    },
    "title": "Información de la ejecución",
    "snapshot": {
      "portfolioLine": "{{total}} carteras · {{rebalanced}} rebalanceadas · {{failed}} fallidas · {{skipped}} omitidas",
      "totalSells": "{{value}} ventas",
      "totalBuys": "{{value}} compras",
      "proposedTrades": "{{count}} operaciones propuestas",
      "auditsReviewed": "{{count}} carteras con detalle de auditoría"
    },
    "impact": {
      "title": "Resumen de impacto",
      "shelteredOnly": "Toda la actividad de venta estuvo protegida fiscalmente",
      "taxShelteredPct": "El {{value}}% de la actividad de venta está protegida fiscalmente",
      "noteTaxLocation": "Ubicación fiscal aplicada en {{count}} cartera(s)",
      "noteLiquidation": "Liquidación total en {{count}} cartera(s)",
      "noteFx": "Exposición a FX marcada en {{count}} cartera(s)",
      "noteSwitch": "Oportunidades de cambio en {{count}} cartera(s)",
      "noteCovariance": "Asignación más simple utilizada en {{count}} cartera(s)",
      "noteCashRaise": "Aumento de efectivo en {{count}} cartera(s)",
      "noteCashDeploy": "Despliegue de efectivo en {{count}} cartera(s)",
      "noteCash": "Efectivo en {{count}} cartera(s)",
      "noteMultiCurrency": "Multidivisa en {{count}} cartera(s)",
      "noteDefault": "{{label}} en {{count}} cartera(s)",
      "taxableSellsLine": "Ventas gravables {{value}} en {{count}} cartera(s)",
      "taxableSellsGainsFallback": "Puede generar ganancias de capital",
      "estRealizedGainsLine": "Ganancias realizadas estimadas {{value}} en {{count}} cartera(s)",
      "outcomeStrip": "{{succeeded}} aprobadas · {{failed}} fallidas · {{skipped}} omitidas",
      "outcomeStripWithTrades": "{{succeeded}} aprobadas · {{failed}} fallidas · {{skipped}} omitidas · {{sells}} ventas · {{buys}} compras",
      "cashEventsTitle": "Efectivo y divisa",
      "flagsTitle": "Banderas de ejecución",
      "taxTitle": "Impacto fiscal",
      "turnoverTitle": "Rotación",
      "metricsTitle": "Impacto en la cartera",
      "otherNotesTitle": "Otras banderas",
      "turnoverRunCaption": "Rotación típica {{value}}%",
      "tradeMixTitle": "Actividad de operación",
      "tradeMixRaiseCaption": "Con muchas ventas · recaudando efectivo",
      "tradeMixDeployCaption": "Con muchas compras · desplegando efectivo",
      "tradeMixMixedCaption": "Compras y ventas mixtas",
      "tradeMixBuySell": "{{buys}} compras · {{sells}} ventas",
      "estRealizedGainsIncompleteRun": "No se pudieron estimar las ganancias realizadas para {{lineCount}} venta(s) en {{portfolioCount}} cartera(s)",
      "estRealizedGainsUnavailableRun": "No se pudieron estimar las ganancias realizadas para {{count}} cartera(s) con ventas gravables",
      "turnoverTypical": "Rotación típica {{value}}%",
      "turnoverDetailed": "Típica {{median}}% · algunas carteras tan altas como {{p90}}%",
      "turnoverRunFootnote": "Porcentaje de tenencias vendidas y reemplazadas",
      "turnoverRunP90": "Algunas carteras fueron tan altas como {{value}}%",
      "topTaxableSellsTitle": "Ventas gravables",
      "topShelteredSellsTitle": "Ventas protegidas fiscalmente",
      "topBatchSellsTitle": "Principales ventas",
      "topBatchBuysTitle": "Principales compras",
      "tickerGridAmountColumn": "Monto",
      "tickerGridTickerColumn": "Símbolo"
    },
    "reviewNext": {
      "title": "Revisar siguientes",
      "subtitle": "Carteras con los mayores cambios propuestos en esta ejecución.",
      "movement": "Movimiento",
      "flags": "Banderas",
      "open": "Abrir",
      "viewAll": "Ver todas las carteras",
      "badgeFailed": "Fallida",
      "badgeTax": "Impuestos",
      "badgeHighTurnover": "Alta rotación",
      "badgeLiquidate": "Liquidación",
      "badgeTransfer": "Retiro pendiente",
      "filter": {
        "all": "Todas",
        "passed": "Aprobadas",
        "failed": "Fallidas",
        "liquidate": "Liquidación",
        "transfer": "Retiro pendiente",
        "tax": "Impuestos",
        "highTurnover": "Alta rotación"
      }
    },
    "summaryFailed": "{{count}} fallidas"
  },
  "reports": {
    "filterModelSelected": "{{label}} ({{count}})",
    "filterModelOption": "{{label}} ({{count}})",
    "filterAssetSelected": "{{ticker}} ({{count}})",
    "client": "Cliente / unidad familiar",
    "portfolio": "Cartera",
    "accounts": "Cuentas",
    "status": "Estado",
    "trades": "Operaciones",
    "scopeType": "Alcance",
    "goal": "Meta",
    "model": "Modelo",
    "marketValue": "Valor de mercado",
    "driftRequired": "Desviación",
    "cashTrigger": "Disparador de efectivo",
    "tradeRequests": "Solicitudes de operación",
    "expandedTradeSummary": "{{count}} operaciones propuestas · {{buys}} compras · {{sells}} ventas",
    "noAuditDetail": "El detalle de la operación no está disponible para esta cartera.",
    "statusPassed": "Aprobado",
    "statusFailed": "Fallido",
    "viewChanges": "Ver cambios",
    "noImpactFilterMatches": "Ninguna cartera coincide con este filtro en la página actual.",
    "noFilterMatches": "Ninguna cartera coincide con los filtros actuales.",
    "filterSearchPlaceholder": "Buscar cartera",
    "filterModelLabel": "Modelo",
    "filterAssetLabel": "Valor",
    "filterModelAll": "Todos los modelos",
    "filterAssetAll": "Cualquier valor",
    "filterAssetOption": "{{ticker}} · {{count}} carteras",
    "filterClear": "Borrar",
    "filterSummary": "{{count}} carteras coincidentes",
    "filterScopeNotice": "Los filtros se aplican a {{loaded}} de {{total}} carteras cargadas.",
    "filterAssetScopeNotice": "{{shown}} mostradas aquí · {{total}} carteras operaron este valor en la ejecución.",
    "unresolvedPortfolio": "Cartera no disponible",
    "unresolvedPortfolioHint": "Nombre del cliente no disponible — los tipos de cuenta se enumeran en la columna Cuentas",
    "sleeveCount": "{{count}} subcuentas",
    "openDetailAria": "Abrir cartera {{name}}"
  },
  "drawer": {
    "atTarget": "✓",
    "selling": "Venta",
    "buying": "Compra",
    "trades": "Operaciones propuestas",
    "positionsChanged": "Posiciones cambiadas",
    "exitsSummary": "{{count}} salida(s): {{tickers}}",
    "entriesSummary": "{{count}} nueva(s) posición(es): {{tickers}}",
    "exitChip": "Salir de {{ticker}}",
    "entryChip": "Nuevo {{ticker}}",
    "accountCount": "{{count}} subcuentas",
    "holdingChangesTitle": "Cambios en las tenencias",
    "expandHint": "Expanda las filas para ver cómo se dividen las operaciones entre las subcuentas.",
    "security": "Valor",
    "target": "Objetivo",
    "before": "Antes",
    "after": "Después",
    "change": "Cambio",
    "newPosition": "Nuevo",
    "exitPosition": "Salida",
    "sellToCashPosition": "Vender",
    "cashEventWithdrawalTitle": "Retiro pendiente",
    "cashEventLiquidationTitle": "Liquidación",
    "cashEventNoticeBody": "Las ventas propuestas aumentan el efectivo en el momento de la ejecución — los objetivos del modelo siguen aplicándose a largo plazo. Las celdas de las subcuentas muestran los montos de venta, no una salida permanente a $0.",
    "cashEventSellsSummary": "{{count}} venta(s) para aumentar el efectivo: {{tickers}}",
    "atTargetLabel": "En el objetivo",
    "offTarget": "Fuera del objetivo",
    "noWeightDiffs": "No se registraron cambios en las tenencias para esta cartera.",
    "validationFailedTitle": "No se pudo rebalancear esta cartera",
    "validationWarningTitle": "Revise antes de continuar",
    "unreliableSnapshotTitle": "Los datos de las tenencias parecen poco fiables",
    "unreliableSnapshotBody": "Esta ejecución registró un valor de mercado igual al efectivo mientras aún vendía posiciones, por lo que las tenencias previas a la operación no se pueden mostrar con precisión. Abra la página de la cartera para revisar las posiciones reales.",
    "liquidateTriggerNotice": "Esta cartera tuvo una liquidación en el momento de la ejecución. Revise la actividad de efectivo y retiro en la página de la cartera.",
    "transferTriggerNotice": "Esta cartera tuvo un retiro pendiente en el momento de la ejecución. Las ventas propuestas pueden estar impulsadas por ese evento de efectivo en lugar de la desviación del modelo.",
    "unresolvedPortfolioNotice": "La instantánea de la cartera no está disponible para esta fila. Los detalles de validación a continuación provienen de la auditoría del optimizador (informe {{reportId}}).",
    "reviewPortfolioHint": "Abra la página de la cartera para revisar las tenencias, el efectivo y los detalles a nivel de cuenta que la ejecución de rebalanceo no puede mostrar aquí.",
    "reviewPortfolioUnresolvedHint": "Esta ejecución solo tiene datos de auditoría del optimizador para esta cartera. Abra la página de la cartera para inspeccionar directamente las tenencias y las posiciones de efectivo.",
    "reviewPortfolioOpen": "Abrir cartera",
    "modelTargetWeight": "Objetivo del modelo: {{amount}} de activos invertibles",
    "auditGrid": {
      "proposed": "Propuesto",
      "multiCurrencyCashTooltip": "Efectivo actual por divisa. El total propuesto está en la divisa base de la cartera."
    },
    "snapshotNotice": "Los valores reflejan la cartera en el momento de la ejecución."
  },
  "title": "Rebalanceo Masivo",
  "detailTitle": "Ejecución de rebalanceo",
  "listPlaceholder": "El historial de ejecuciones y el flujo de inicio de ejecución aparecerán aquí.",
  "detailPlaceholder": "La cabina de ejecución para {{runId}} aparecerá aquí.",
  "breadcrumbRun": "Ejecución {{runId}}",
  "table": {
    "newRun": "Nueva ejecución de rebalanceo",
    "createdAt": "Creado el",
    "byCreator": "Por {{name}}",
    "type": "Tipo de rebalanceo",
    "status": "Estado",
    "result": "Resultado",
    "empty": "Aún no hay ejecuciones de rebalanceo en vivo. Inicie una ejecución cuando esté listo para rebalancear carteras elegibles.",
    "organization": "Organización",
    "openRunAria": "Abrir ejecución de rebalanceo de {{when}}, {{type}}"
  },
  "outcome": {
    "rebalanced": "{{count}} rebalanceadas",
    "failed": "{{count}} fallidas",
    "skipped": "{{count}} omitidas",
    "none": "Ninguna cartera procesada",
    "processing": "Procesando carteras…",
    "processingTotal": "0 de {{total}} carteras procesadas",
    "processingProgress": "{{processed}} de {{total}} carteras procesadas"
  },
  "actionHint": {
    "preview": "Solo vista previa",
    "reviewResults": "Revisar resultados",
    "running": "En curso",
    "failed": "Ejecución fallida",
    "review": "Revisar ejecución"
  },
  "duration": {
    "completedIn": "Completado en {{value}}"
  },
  "audit": {
    "title": "Resumen de auditoría",
    "portfoliosReviewed": "{{count}} carteras revisadas",
    "proposedTrades": "{{count}} operaciones propuestas",
    "totalBuys": "{{value}} compras",
    "totalSells": "{{value}} ventas",
    "validationIssues": "{{count}} problemas de validación",
    "portfoliosWithValidationIssues": "{{count}} cartera(s) no pasaron la validación",
    "validationIssuesUnknown": "Revise las carteras individuales para obtener detalles de validación.",
    "validationFailedUnknown": "La validación falló sin mensaje detallado.",
    "materialDecisions": "{{count}} ajuste(s) notable(s)",
    "avgSolveTime": "Tiempo promedio de resolución {{value}}"
  },
  "validationDiagnostics": {
    "account": "Cuenta",
    "unknownTicker": "Activo desconocido",
    "negativePortfolioCash": "{{value}} efectivo de cartera",
    "negativeAccountCash": "{{account}}: {{value}} efectivo",
    "accountMarketValue": "Valor de mercado de {{account}}: {{value}}",
    "negativeHoldingQuantity": "{{accountPrefix}}{{ticker}}: {{quantity}} acciones ({{value}})",
    "negativeHoldingValue": "{{accountPrefix}}{{ticker}}: {{value}} posición",
    "belowMinimumPortfolioMarketValue": "Valor de mercado de la cartera {{value}} (por debajo del mínimo de $1.00)"
  },
  "validationErrors": {
    "nonPositiveMarketValue": "Valor de mercado no viable — a menudo causado por efectivo o activos negativos",
    "negativeQuantity": "Cantidad de posición negativa detectada",
    "noSubAccounts": "La cartera no tiene subcuentas",
    "weightsSumMismatch": "Los pesos objetivo no suman correctamente",
    "invalidCurrency": "Moneda inválida en un activo",
    "nonPositivePrice": "Precio no positivo en un activo",
    "invalidModelPortfolioType": "Tipo de cartera no compatible para optimización",
    "assetClassTargetsSumMismatch": "Los objetivos de clase de activos no suman correctamente",
    "unknownCode": "Problema de validación: {{code}}"
  },
  "filters": {
    "type": "Tipo",
    "state": "Estado",
    "allTypes": "Todos los tipos",
    "allStates": "Todos los estados",
    "clear": "Borrar filtros"
  },
  "runType": {
    "DRIFT": "Rebalanceo por desviación",
    "TRANSFER": "Rebalanceo de efectivo",
    "ALL_ELIGIBLE": "Rebalanceo de todos los elegibles"
  },
  "runTypeDescription": {
    "DRIFT": "Rebalancea carteras que se han desviado de su asignación objetivo.",
    "TRANSFER": "Rebalancea carteras con efectivo disponible o un disparador de efectivo, como nuevas contribuciones o retiros pendientes.",
    "ALL_ELIGIBLE": "Rebalancea cada cartera con un disparador activo: efectivo o eventos de efectivo, necesidades de liquidación o desviación más allá de la asignación objetivo."
  },
  "runMode": {
    "DRY_RUN": "Simulación",
    "LIVE": "En vivo"
  },
  "runPreset": {
    "V1_COMPATIBLE": "Compatible con V1"
  },
  "runState": {
    "INITIATED": "Iniciado",
    "OPTIMIZING": "Optimizando",
    "VALIDATING": "Validando",
    "PUBLISHING": "Publicando",
    "COMPLETED": "Completado",
    "FAILED": "Fallido"
  },
  "scopeType": {
    "GOAL": "Meta",
    "SUB_ACCOUNT": "Subcuenta",
    "HOUSEHOLD": "Unidad familiar"
  },
  "insights": {
    "title": "Información del rebalanceo",
    "summaryTaxableSells": "Ventas gravables {{value}}",
    "summaryShelteredSells": "Solo ventas protegidas fiscalmente",
    "changesSectionTitle": "Qué está cambiando",
    "triggerDrift": "Rebalanceo por desviación",
    "triggerLiquidate": "Liquidación",
    "triggerTransfer": "Retiro pendiente",
    "whyRaisingCash": "Aumentando {{value}} para financiar un retiro",
    "whyDeployingCash": "Desplegando {{value}} de contribución",
    "newPositionsLabel": "Nuevas posiciones",
    "soldToRaiseCashLabel": "Vendido para aumentar el efectivo",
    "exitedLabel": "Salida",
    "broughtToTarget": "Se rebalancearon {{count}} tenencias a su objetivo",
    "taxSectionTitle": "Impacto fiscal y en la cuenta",
    "registeredSells": "Ventas registradas: {{value}}",
    "registeredSellsHint": "Sin ganancias de capital",
    "taxableSells": "Ventas gravables: {{value}}",
    "taxableSellsHint": "Puede generar ganancias",
    "noTaxableSellsHint": "Ninguna",
    "registeredSellPct": "El {{value}}% de la actividad de venta está protegida fiscalmente",
    "shelteredVsTaxable": "{{sheltered}} protegidas · {{taxable}} gravables",
    "turnoverSectionTitle": "Rotación",
    "situationsSectionTitle": "Consideraciones adicionales",
    "decisionsSectionTitle": "Otros ajustes",
    "liquidationSummary": "{{account}} totalmente liquidada — {{reason}}",
    "liquidationWithdraw": "Transferencia de retiro total pendiente",
    "liquidationCashTarget": "El objetivo de efectivo excede el valor de la cuenta",
    "taxLocationApplied": "Ubicación fiscal aplicada en {{subAccountCount}} subcuentas y {{holdingCount}} tenencias",
    "taxLocationFlow": "Neto ~{{value}} transferido de {{from}} a {{to}}",
    "taxLocationSkipped": "Ubicación fiscal no aplicada: {{reason}}",
    "cashRaiseApplied": "Se recaudó {{amount}} de {{count}} tenencia(s)",
    "cashRaiseAppliedFrom": "Se recaudó {{amount}} de {{holding}} en {{account}}",
    "cashRaiseBlockedMultiCurrency": "No se pudo recaudar efectivo — esta es una cuenta multidivisa",
    "cashDeployApplied": "Se desplegó {{amount}} en {{count}} tenencia(s)",
    "cashDeployAppliedFrom": "Se desplegó {{amount}} a {{holding}} en {{account}}",
    "cashDeployBlockedMultiCurrency": "No se pudo desplegar efectivo — esta es una cuenta multidivisa",
    "multiCurrencyAccount": "Esta es una cuenta multidivisa",
    "multiCurrencyCashStays": "El efectivo solo compra tenencias en la misma moneda",
    "multiCurrencyCouldNotSeparate": "No se pudieron mantener las monedas separadas — las operaciones pueden mezclar monedas",
    "multiCurrencyMixedFunding": "Una moneda se financió con efectivo de otra moneda",
    "multiCurrencyNeedsConversion": "La mezcla de monedas está fuera del modelo — necesita un depósito, retiro o conversión",
    "decisionStage": {
      "cashRaise": "Aumento de efectivo",
      "cashDeploy": "Despliegue de efectivo",
      "cash": "Efectivo",
      "multiCurrency": "Multidivisa"
    },
    "taxLocationDegenerate": "Ubicación fiscal no necesaria — todas las tenencias comparten el mismo rango fiscal",
    "fxExposure": "Exposición a FX en {{holdingCount}} tenencia(s) en {{currencies}} (~{{bps}} bps de costo estimado)",
    "switchOpportunitiesPrefix": "Oportunidades de cambio:",
    "covarianceFallback": "La optimización consciente del riesgo no estaba disponible; se utilizó un modelo de asignación más simple",
    "qpFailed": "Optimización fallida: {{reason}}",
    "ai": {
      "generate": "Generar información",
      "regenerate": "Regenerar",
      "loading": "Escribiendo resumen…",
      "error": "No se pudo generar la información. Inténtelo de nuevo.",
      "disclaimerTitle": "Acerca de la información de IA",
      "disclaimer": "Este es un borrador generado a partir de los números ya presentes en esta página. No es un consejo. Verifique los tickers, montos y notas fiscales con la información estructurada.",
      "generateShort": "Generar notas",
      "portfolio": {
        "title": "Notas del asesor"
      },
      "run": {
        "title": "Notas del asesor"
      },
      "subtitle": "Resumen interpretativo — las métricas estructuradas anteriores son autorizadas.",
      "betaLabel": "Experimental"
    },
    "estRealizedGainsHint": "Ganancias realizadas estimadas {{value}}",
    "summaryEstRealizedGains": "Ganancias estimadas {{value}}",
    "metricsSectionTitle": "Impacto en la cartera",
    "turnoverHoldingCount": "En {{count}} tenencias",
    "summaryTurnover": "Rotación del {{value}}%",
    "triggerScopedCash": "Efectivo por subcuenta",
    "scopedCashPreview": "Rebalanceo de efectivo por subcuenta",
    "scopedCashMixedHint": "Ejecución de recaudación y despliegue en diferentes subcuentas en la misma pasada.",
    "whyDeployedCashOnSleeve": "Se desplegó {{value}} en una subcuenta",
    "turnoverMeterHeadline": "El {{value}}% de las tenencias vendidas y reemplazadas",
    "turnoverBuySell": "Comprar {{buyPct}}% · Vender {{sellPct}}%",
    "turnoverSummary": "El {{turnoverPct}}% de las tenencias vendidas y reemplazadas en {{holdingCount}} tenencias · comprar {{buyPct}}%, vender {{sellPct}}%",
    "estRealizedGainsIncompleteLine": "No se pudieron estimar las ganancias realizadas para {{count}} venta(s) gravable(s)",
    "estRealizedGainsUnavailable": "No se pudieron estimar las ganancias realizadas",
    "failureReasonPortfolioCount_one": "{{label}} · 1 cartera",
    "failureReasonPortfolioCount_other": "{{label}} · {{count}} carteras",
    "aiHighlightFailedValidation": "Validación fallida",
    "aiHighlightTaxableSells": "Ventas gravables",
    "aiHighlightHighTurnover": "Alta rotación",
    "aiHighlightTypicalPct": "típico {{value}}%",
    "aiHighlightHighestPct": "más alto {{value}}%"
  },
  "detail": {
    "startedAt": "Iniciado el {{value}}",
    "updatedAt": "Actualizado el {{value}}",
    "outcomeLabel": "Resultado: {{value}}",
    "progressLabel": "Progreso de la ejecución",
    "progressStateDescription": {
      "INITIATED": "Iniciando ejecución de rebalanceo…",
      "OPTIMIZING": "Calculando asignaciones objetivo y operaciones propuestas.",
      "VALIDATING": "Verificando datos de cartera y resultados de optimización.",
      "PUBLISHING": "Publicando informes de carteras rebalanceadas."
    },
    "progressProcessedCount": "{{processed}} de {{total}} carteras procesadas",
    "progressPreviewCount": "{{count}} cartera(s) lista(s) para previsualizar",
    "progressPollingNotice": "Los resultados aparecerán a continuación a medida que cada cartera se complete.",
    "reportsTitle": "Carteras rebalanceadas",
    "noReports": "No se publicaron informes de carteras rebalanceadas para esta ejecución.",
    "noDryRunReports": "No se encontraron carteras rebalanceadas para esta simulación.",
    "inProgressNotice": "Esta ejecución aún está en proceso. Los informes aparecerán cuando se complete.",
    "failedNotice": "Esta ejecución falló antes de publicar los informes de carteras rebalanceadas.",
    "dryRunCompleteNotice": "Las simulaciones son solo para previsualización. Inicie una ejecución en vivo cuando esté listo para enviar operaciones.",
    "zeroSucceededNotice": "No se rebalancearon carteras en esta ejecución. Revise la elegibilidad o intente de nuevo después de abordar los saltos y fallos.",
    "proceedToBulkTrader": "Proceder al operador masivo",
    "proceedDryRunBlocked": "Las operaciones masivas solo se pueden generar a partir de una ejecución en vivo completada.",
    "proceedZeroSucceededBlocked": "No hay carteras rebalanceadas para enviar al operador masivo.",
    "proceedMissingPermission": "Necesita el permiso write:bulk_trade_run para proceder al operador masivo."
  },
  "reviewTrades": {
    "title": "Revisar operaciones",
    "openStep": "Revisar operaciones",
    "backToResults": "Volver a los resultados de la ejecución",
    "subtitle": "{{count}} solicitud(es) de operación de esta ejecución",
    "empty": "No se crearon solicitudes de operación para esta ejecución.",
    "truncated": "Mostrando las primeras {{shown}} de {{total}} solicitudes de operación.",
    "unverifiedCount": "{{count}} necesitan aprobación",
    "unverifiedNotice": "Apruebe las solicitudes de operación restantes antes de continuar.",
    "evaluating": "Aplicando programas de operación…",
    "unknownPortfolio": "Cartera desconocida",
    "sharesAll": "Todas",
    "groupTradeCount_one": "{{count}} operación",
    "groupTradeCount_other": "{{count}} operaciones",
    "groupBuy": "comprar {{amount}}",
    "groupSell": "vender {{amount}}",
    "evaluateError": "No se pudieron aplicar los programas de operación.",
    "cancelError": "No se pudieron cancelar las solicitudes de operación.",
    "approveError": "No se pudieron aprobar las solicitudes de operación.",
    "cancelSuccess": "Se cancelaron {{count}} solicitud(es) de operación.",
    "approveSuccess": "Se aprobaron {{count}} solicitud(es) de operación.",
    "proceedNoTrades": "No hay solicitudes de operación activas para enviar al operador masivo.",
    "proceedNeedsApproval": "Apruebe las solicitudes de operación restantes antes de proceder al operador masivo.",
    "proceedWaiting": "Las solicitudes de operación aún están llegando para esta ejecución.",
    "proceedEvaluating": "Los programas de operación aún se están aplicando.",
    "proceedMissingEvaluatePermission": "Necesita el permiso write:sub_trade_request para aplicar programas de operación.",
    "approveSelected": "Aprobar seleccionados",
    "cancelSelected": "Cancelar seleccionados",
    "cancelAll": "Cancelar todo",
    "cancelRow": "Cancelar",
    "cancelAllTitle": "¿Cancelar todas las solicitudes de operación?",
    "cancelAllBody": "Esto cancela permanentemente cada operación pendiente de esta ejecución. No se pueden regenerar desde esta página.",
    "cancelAllConfirm": "Cancelar todas las operaciones",
    "cancelSelectedTitle": "¿Cancelar las solicitudes de operación seleccionadas?",
    "cancelSelectedBody": "Esto cancela permanentemente {{count}} solicitud(es) de operación. No se pueden regenerar desde esta página.",
    "cancelRowTitle": "¿Cancelar esta solicitud de operación?",
    "cancelRowBody": "Esto cancela permanentemente {{ticker}}. No se puede regenerar desde esta página.",
    "cancelRowFallback": "esta solicitud de operación",
    "cancelRowConfirm": "Cancelar operación",
    "cancelConfirm": "Cancelar operaciones",
    "keepTrades": "Mantener operaciones",
    "columns": {
      "type": "Tipo",
      "amount": "Monto",
      "price": "Precio",
      "shares": "Acciones",
      "account": "Cuenta",
      "status": "Estado",
      "note": "Nota",
      "security": "Cartera / valor",
      "portfolio": "Cartera",
      "sleeves": "Subcuentas"
    },
    "status": {
      "READY": "Listo",
      "HELD": "Retenido",
      "INITIATED": "Pendiente",
      "CANCELED": "Cancelado",
      "REQUESTED": "Solicitado",
      "RECONCILED": "Conciliado",
      "VERIFIED": "Aprobado"
    },
    "holdReason": {
      "schedule": "Programado {{date}}",
      "blockedUntil": "Retenido hasta {{date}}",
      "accountInactive": "Cuenta inactiva",
      "subAccountInactive": "Subcuenta inactiva"
    },
    "note": {
      "awaitingProceeds": "Esperando ganancias de venta",
      "awaitingProceedsTooltip": "Esta compra necesita efectivo de una venta que se liquida más tarde.",
      "awaitingProceedsWithTickerTooltip": "Necesita efectivo de {{ticker}}, que se liquida más tarde que esta compra.",
      "pendingWithdraw": "Efectivo reservado para un retiro",
      "pendingWithdrawTooltip": "El efectivo disponible está retenido para un retiro pendiente, por lo que esta compra está esperando para evitar operaciones adicionales."
    },
    "type": {
      "BUY": "Comprar",
      "SELL": "Vender"
    },
    "readyCount": "{{count}} Listas",
    "heldCount": "{{count}} Retenidas",
    "pendingCount": "{{count}} Pendientes",
    "canceledCount": "{{count}} Canceladas",
    "filterSearchPlaceholder": "Buscar cliente, cartera o ticker",
    "filterClear": "Borrar filtros",
    "filterNoMatches": "Ninguna operación coincide con los filtros actuales.",
    "filterResults": "Mostrando {{portfolioCount}} carteras · {{tradeCount}} operaciones",
    "expandAll": "Expandir todo",
    "collapseAll": "Contraer todo",
    "filterStatus": {
      "all": "Todas",
      "ready": "Listas",
      "held": "Retenidas",
      "pending": "Pendientes",
      "canceled": "Canceladas",
      "needsApproval": "Necesitan aprobación"
    },
    "toggleGroupAria": "Alternar operaciones para {{name}}",
    "selectAllAria": "Seleccionar todas las operaciones procesables",
    "selectTradeAria": "Seleccionar operación de {{ticker}}",
    "cancelAllFilteredTitle": "¿Cancelar solicitudes de operación coincidentes?",
    "cancelAllFilteredBody": "Esto cancela permanentemente {{count}} solicitud(es) de operación pendiente(s) que coinciden con sus filtros actuales. Las operaciones ocultas no se cancelan. No se pueden regenerar desde esta página.",
    "settlementBadge": "T más {{days}} día(s)"
  },
  "startRun": {
    "title": "Iniciar ejecución de rebalanceo",
    "typeLabel": "Enfoque de rebalanceo",
    "modeLabel": "Modo de ejecución",
    "presetLabel": "Preajuste",
    "presetLockedHelp": "Compatible con V1 es el único preajuste compatible por ahora.",
    "cancel": "Cancelar",
    "confirm": "Iniciar ejecución",
    "driftToleranceDefaultNote": "Incluye carteras ya marcadas más allá de la tolerancia de desviación predeterminada del {{percent}}%.",
    "changeDriftTolerance": "Cambiar en la configuración de operaciones",
    "driftToleranceNote": "Incluye carteras que el motor de desviación ya ha marcado contra la propia tolerancia de cada cartera."
  },
  "rebalanceMode": {
    "DEPLOY_CASH": "Desplegar efectivo",
    "RAISE_CASH": "Recaudar efectivo",
    "FULL_REBALANCE": "Rebalanceo completo"
  },
  "accountTypeChip": {
    "PERSONAL": "No registrado",
    "CORPORATE": "Corp."
  }
}
